import { render, staticRenderFns } from "./PacklistItemsV4.vue?vue&type=template&id=2c05eb40&scoped=true"
import script from "./PacklistItemsV4.vue?vue&type=script&lang=js"
export * from "./PacklistItemsV4.vue?vue&type=script&lang=js"
import style0 from "./PacklistItemsV4.vue?vue&type=style&index=0&id=2c05eb40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c05eb40",
  null
  
)

export default component.exports